<template>
  <div>
    <div class="vx-row">
      <vx-card>
        <vs-table
          :max-items="descriptionItems[1]"
          pagination
          :data="historyList"
          description
          search
          :description-items="descriptionItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <div class="vx-col w-full">
              <ul class="heading-ul mb-5">
                <li>
                  <router-link :to="{ path: '/scheduler_jobs' }" class="vx-row">
                    <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                    <h4 class="list-heading">
                      {{ $t("admin.label.Scheduler Job History") }}
                    </h4>
                  </router-link>
                </li>
              </ul>
            </div>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("admin.label.Version") }}</vs-th>
            <vs-th>{{ $t("admin.label.Run Start Time") }}</vs-th>
            <vs-th>{{ $t("admin.label.Status") }}</vs-th>
            <vs-th>{{ $t("admin.label.Run Type") }}</vs-th>
            <vs-th>{{ $t("admin.label.Log File") }}</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="index" :data="item" v-for="(item, index) in data">
              <vs-td :data="item.version">{{ item.version }}</vs-td>
              <vs-td :data="item.jobRunStartTime">{{ item.jobRunStartTime }}</vs-td>
              <vs-td :data="item.status">{{ item.status }}</vs-td>
              <vs-td :data="item.triggerType">{{ item.triggerType }}</vs-td>
              <vs-td class="whitespace-no-wrap"
                >
                <!-- <feather-icon
                  icon="DownloadIcon"
                  title="download"
                  svgClasses="w-5 h-5 text-danger stroke-current"
                  @click.stop="handleDownload(item.historyId)"
                  class="ml-2 cursor-pointer text-warning"
                /> -->
                 <feather-icon
                  v-if="item.status === 'failed'"
                  icon="EyeIcon"
                  class="ml-2 cursor-pointer text-primary"
                  svgClasses="w-5 h-5 stroke-current"
                  @click="showErrorDetails(item)"
                />
            </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <vs-popup 
      classContent="popup-example" 
      title="Error Details" 
      :active.sync="showErrorPopup"
      class="popup-close"
    >
      <div>
        <p>
          <strong>Error Message:</strong>
        </p>
        <p class="mb-3" style="color:red;">
          {{ selectedError.jobRunErrorMessage }}
        </p>
        <hr />
        <p class="mt-3">
          <strong>Error Log:</strong>
        </p>
        <pre 
          class="text-dark"
          style="max-height: 300px; 
          overflow-y: auto; 
          background: #f8f9fa; 
          padding: 10px;"
        >
          {{ selectedError.jobRunErrorLog }}
        </pre>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { BUCKET_BASE_URL } from "@/http/index";

export default {
  data() {
    return {
      searchOption: 0,
      descriptionItems: [5, 10, 15],
      id: "",
      showErrorPopup: false,
      selectedError: {}
    };
  },

  computed: {
    ...mapState({
      // items: (state) => state.masters.itemList,
      historyList: (state) => state.admin.schedulerHistory,
    }),
  },
  methods: {
    handleDownload(id) {
      window.open(BUCKET_BASE_URL + `/jobs/printlog/${id}?tenantIdentifier=default`);
    },
    async getItemList() {
      try {
        await this.$store.dispatch("admin/schedulerHistoryAction", this.id);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    editData(id) {
      this.$router.push(`/edititem/${id}`);
    },
    showErrorDetails(item) {
      this.selectedError = {
        jobRunErrorLog: item.jobRunErrorLog,
        jobRunErrorMessage: item.jobRunErrorMessage,
      };
      this.showErrorPopup = true;
    },

  },
  mounted() {
    this.id = this.$route.params.id;
    this.getItemList();
  },
};
</script>
<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
</style>
